import React from 'react'
import { Link } from 'react-scroll'
import './header.css'
import { motion } from 'framer-motion'

function Header({
    topLine,
    headingText,
    RootName,
    desc,
    AnimateImg,
}) {
    return (
        <div className='header-section' id="Home">
            <div className="margin--align home--grid">
                <div className="left--container">
                    <div className='top-line'>
                        {topLine}
                    </div>
                    <h1 className='heading-text'>
                        {headingText} <span>{RootName}</span>
                    </h1>
                    <p className='desc'>
                        {desc}
                    </p>
                </div>
                <div className="right--container">
                    <img src={AnimateImg} alt="" />
                </div>
            </div>
        </div>
    )
}

export default Header
